import { render, staticRenderFns } from "./cryptoTraderHistory.vue?vue&type=template&id=4dfb1c68"
import script from "./cryptoTraderHistory.vue?vue&type=script&lang=js"
export * from "./cryptoTraderHistory.vue?vue&type=script&lang=js"
import style0 from "./cryptoTraderHistory.vue?vue&type=style&index=0&id=4dfb1c68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports